<ng-container *ngIf="!!params">
    <tt-select
        ttLabel="productsetting"
        [(ttModel)]="params.productsetting_keyno"
        (ttModelChange)="onChanged('productsetting_keyno')"
        [ttData]="productSettings"
        ttDataId="item_id"
        ttDataName="item_name"
    ></tt-select>
    <tt-select ttLabel="language" [(ttModel)]="params.language_id" (ttModelChange)="onChanged('language_id')" [ttData]="languages" ttDataId="item_id" ttDataName="item_name"></tt-select>
    <tt-product-setting-mcs-form [hideCounterAfterAssign]="true" [(data)]="pimFields" [items]="pimFieldsItems"></tt-product-setting-mcs-form>
    <tt-button-save ttText="product_pimdata_save" (ttClick)="savePimData()" [ttLoading]="savingPimData"></tt-button-save>
</ng-container>
